import { render, staticRenderFns } from "./PlatformList.vue?vue&type=template&id=4bc064ed&scoped=true&"
import script from "./PlatformList.vue?vue&type=script&lang=js&"
export * from "./PlatformList.vue?vue&type=script&lang=js&"
import style0 from "./PlatformList.vue?vue&type=style&index=0&id=4bc064ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc064ed",
  null
  
)

export default component.exports